import { render, staticRenderFns } from "./ExternalMark.vue?vue&type=template&id=018dbf77&scoped=true"
import script from "./ExternalMark.vue?vue&type=script&lang=js"
export * from "./ExternalMark.vue?vue&type=script&lang=js"
import style0 from "./ExternalMark.vue?vue&type=style&index=0&id=018dbf77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018dbf77",
  null
  
)

export default component.exports